import { Injectable, Inject, Optional, TransferState, makeStateKey } from '@angular/core';
import { environment } from '../../../environments/environment';

const ENV_VARS_KEY = makeStateKey('envVars');
const IP_ADDRESS_KEY = makeStateKey('ipAddress');

@Injectable({
  providedIn: 'root'
})
export class MktEnvironmentService {
  private envVars;
  private ipAddress;

  constructor(
    @Optional() @Inject('ENV_VARS_FROM_SERVER') private envVarsFromServer: string,
    @Optional() @Inject('IP_ADDRESS') private ipAddressFromServer: string,
    private state: TransferState
  ) {

    this.envVars = this.state.get(ENV_VARS_KEY, null as any);
    this.ipAddress = this.state.get(IP_ADDRESS_KEY, null as any);

    if (!this.envVars) {
      this.setEnvVars();
    }

    if (!this.ipAddress) {
      this.ipAddress = this.ipAddressFromServer;
      this.state.set(IP_ADDRESS_KEY, this.ipAddress);
    }
  }

  public getEnvironmentVar(varName) {
    // If the system variables are available via node
    // Else if the environment.ts variables are available
    if (!!this.envVars) {
      if (varName === 'IP_ADDRESS') {
        return this.ipAddress;
      } else {
        return this.deepClone(this.envVars)[varName];
      }
    } else if (environment[varName]) {
      return this.deepClone(environment)[varName];
    }
  }

  private setEnvVars() {
    this.envVars = {
      ...this.deepClone(environment),
      ...this.deepClone(this.envVarsFromServer)
    };

    this.state.set(ENV_VARS_KEY, this.envVars);
  }

  private deepClone(obj) {
    return JSON.parse(JSON.stringify(obj || {}));
  }
}
